import React, { useState } from 'react';

import { Icon, message, Upload } from 'antd';
import { useTranslation } from 'react-i18next';

import { INSERTS_TAB } from './translationValues';
import { uploadInsert } from '../../../utils/services/insertsApi';
import { INSERT_NAMESPACES } from '../../../utils/insertsHelper';

const accept = '.pdf';
const acceptedExtension = ['pdf'];

export const UploadInserts = ({ onSuccess }) => {
  const { t } = useTranslation(INSERT_NAMESPACES);

  const [loading, setLoading] = useState(false);

  const customRequest = async ({ file }) => {
    let fileName = file.name.split('.');
    let fileExtension = fileName[fileName.length - 1].toLowerCase();
    let isValidFileExtension = acceptedExtension.some(data => {
      return data === fileExtension;
    });
    if (!isValidFileExtension) {
      message.error(
        t(
          INSERTS_TAB.UPLOADED_FILE_EXTENSION_ERROR_MESSAGE.key,
          INSERTS_TAB.UPLOADED_FILE_EXTENSION_ERROR_MESSAGE.value,
          { value: acceptedExtension.join(', ') },
        ),
      );
    } else {
      setLoading(true);
      try {
        const response = await uploadInsert(file);
        if (response.statusCode === 125) {
          message.success(t(
            INSERTS_TAB.INSERT_UPLOAD_SUCCESS.key,
            INSERTS_TAB.INSERT_UPLOAD_SUCCESS.value,
          ));
          onSuccess && onSuccess();
        }
      } catch (e) {
        message.error(t(
          INSERTS_TAB.INSERT_UPLOAD_FAILURE.key,
          INSERTS_TAB.INSERT_UPLOAD_FAILURE.value,
        ));
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Upload customRequest={customRequest} showUploadList={false} accept={accept}>
        {loading ? <Icon type="loading" spin /> : <Icon type="upload" />}{' '}
        {loading
          ? t(INSERTS_TAB.UPLOADING_INSERTS_LABEL.key, INSERTS_TAB.UPLOADING_INSERTS_LABEL.value)
          : t(INSERTS_TAB.UPLOAD_INSERTS_LABEL.key, INSERTS_TAB.UPLOAD_INSERTS_LABEL.value)}
      </Upload>
    </>
  );
};
